import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS, tabletCSS } from '@measures/responsive'
import { StyledBundlingHeader as BundlingHeaderWrapper } from '@components/Bundling/Header'
interface BundlingWrapperProps {
  children?: React.ReactNode
  accentColor?: string
  hasTitle?: boolean
}

type StyledBundlingWrapperProps = Pick<
  BundlingWrapperProps,
  'accentColor' | 'hasTitle'
>

const StyledBundlingWrapper = styled.div<StyledBundlingWrapperProps>`
  ${({
    theme: {
      colors: { staticRed500 },
      measures: {
        stretchWidthOnMobile,
        outerPadding: { mobile: outerPaddingMobile },
      },
      spacing: { spacing32 },
    },
    accentColor,
    hasTitle,
  }) => css`
    display: grid;
    align-items: flex-start;
    grid-template-columns: minmax(0, 1fr);

    ${desktopCSS(css`
      grid-column-gap: ${spacing32};
      grid-template-columns: repeat(12, minmax(0, 1fr));
    `)};

    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: ${hasTitle ? '41px' : '0'};
      left: 0;
      z-index: 1;
      width: calc(100% + 2 * ${outerPaddingMobile});
      ${tabletCSS(css`
        width: 100%;
      `)}
      ${desktopCSS(css`
        width: calc(100% + 30px);
        margin-left: -15px;
        margin-right: -15px;
      `)};
      height: 24px;
      background-color: ${accentColor ?? staticRed500};
      clip-path: polygon(0 0, 100% 0, 0 100%);
      ${stretchWidthOnMobile};
    }

    ${BundlingHeaderWrapper} {
      ${desktopCSS(css`
        grid-column: 1 / -1;
      `)};
    }
  `}
`

const OuterWrapper: FunctionComponent<BundlingWrapperProps> = ({
  children,
  accentColor,
  hasTitle,
}) => {
  return (
    <StyledBundlingWrapper accentColor={accentColor} hasTitle={hasTitle}>
      {children}
    </StyledBundlingWrapper>
  )
}

export default OuterWrapper
